'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.azure.serverGroup.details.azure', [
  require('./serverGroupDetails.azure.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/azure/serverGroup/details/serverGroup.details.module.js